import React, { useState } from 'react';

const Login = ({ onAuth, onFreeAccess }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAuth(password);
  };

  return (
    <div className="login-container">
      <header className="login-header">
        <h1>Salesforce参考問題集</h1>
        <p>
          実践的な問題で学習効果を最大化。<br />
          あなたの資格取得をサポートします。<br />
        </p>
      </header>
      
      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-group">
          <label htmlFor="password">認証コード</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="認証コードを入力してください"
          />
        </div>
        
        <div className="login-buttons">
          <button type="submit" className="login-button">
            学習を始める
          </button>
          <button 
            type="button" 
            onClick={onFreeAccess}
            className="login-button"
          >
            無料プランで体験する
          </button>
        </div>
      </form>
      <p>
        ※本サイトは学習目的で個人的に作成したものです。<br />
        ※掲載されている問題は独自に作成したものであり、正確性や網羅性を保証するものではありません。
      </p>
    </div>
  );
};

export default Login; 
